export default __webpack_public_path__ + "static/media/deletarDark.e7fd1259.svg";